// project import
import NotFound from "./../../components/errors/NotFound";
// ==============================|| ROUTES ITEMS - PROFILE ||============================== //

const notfound = {
    path: "*",
    element: <NotFound />,
};

export default notfound;
